// Vue 2 compatibile - store semplice senza Composition API
const darkModeFromStorage = localStorage.getItem("darkMode") === "true";

const theme = {
  darkMode: darkModeFromStorage,

  toggle() {
    this.darkMode = !this.darkMode;
    localStorage.setItem("darkMode", this.darkMode.toString());
    this.apply();
  },

  apply(currentRoutePath = null) {
    const path = currentRoutePath || window.location.pathname;

    // Controlla se la route corrente ha meta.noDarkMode
    // Questo viene gestito dal router, ma fallback per sicurezza
    if (path === "/" || path === "/welcome" || path === "/users-login") {
      document.body.classList.remove("dm");
      return;
    }

    // Applica dark mode normalmente
    document.body.classList.toggle("dm", this.darkMode);
  },

  updateAfterNavigation(to) {
    // Usa il meta della route per decisioni piu precise
    const noDarkMode = to.matched.some((record) => record.meta.noDarkMode);

    if (noDarkMode) {
      document.body.classList.remove("dm");
    } else {
      document.body.classList.toggle("dm", this.darkMode);
    }

    console.log(
      "Theme applied:",
      noDarkMode ? "Light mode forced" : this.darkMode ? "Dark" : "Light"
    );
  },
};

// Inizializza al caricamento
theme.apply();

export default theme;
export { theme };
